import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { sendError } from "../errors";
import modulesApi from "../api/modules";

export const fetchFormData = createAsyncThunk(
  "salaryCalculator/fetchFormDataStatus",
  (type) =>
    type == "payroll"
      ? modulesApi.fetchPayrollCalculatorFormData()
      : modulesApi.fetchSalaryCalculatorFormData()
);

export const calculateSalary = createAsyncThunk(
  "salaryCalculator/calculateSalaryStatus",
  (data) => modulesApi.calculateSalary(data)
);

export const salaryCalculatorSlice = createSlice({
  name: "salaryCalculator",
  initialState: {
    result: null,
    resultLoaded: false,
    resultLoading: false,
    resultLoadingError: null,
    formDataLoaded: false,
    formDataLoading: false,
    formDataLoadingError: null,
    formData: {},
  },
  reducers: {
    setResult: (state, { payload }) => {
      state.result = payload;
    },
  },
  extraReducers: (builder, x) => {
    builder.addCase(fetchFormData.pending, (state) => {
      state.formDataLoading = true;
      state.formDataLoadingError = null;
    });
    builder.addCase(fetchFormData.fulfilled, (state, action) => {
      state.formData = action.payload;
      state.formDataLoading = false;
      state.formDataLoaded = true;
    });
    builder.addCase(fetchFormData.rejected, (state, action) => {
      sendError(action.error, { filters: state.formData });
      state.formDataLoadingError = action.error;
      state.formDataLoading = false;
      state.formDataLoaded = true;
    });
    builder.addCase(calculateSalary.pending, (state) => {
      state.resultLoading = true;
      state.resultLoadingError = null;
    });
    builder.addCase(calculateSalary.fulfilled, (state, action) => {
      state.result = action.payload;
      state.resultLoading = false;
      state.resultLoaded = true;
    });
    builder.addCase(calculateSalary.rejected, (state, action) => {
      sendError(action.error, { result: state.result });
      state.resultLoadingError = action.error;
      state.resultLoading = false;
      state.resultLoaded = true;
    });
  },
});

// SELECTORS

export const selectResult = (state) => state.salaryCalculator?.result;
export const selectResultLoaded = (state) =>
  state.salaryCalculator?.resultLoaded;
export const selectResultLoading = (state) =>
  state.salaryCalculator?.resultLoading;
export const selectResultLoadingError = (state) =>
  state.salaryCalculator?.resultLoadingError;
export const selectFormData = (state) => state.salaryCalculator?.formData;
export const selectFormDataLoaded = (state) =>
  state.salaryCalculator?.formDataLoaded;
export const selectFormDataLoading = (state) =>
  state.salaryCalculator?.formDataLoading;

// ACTIONS

export const { setResult } = salaryCalculatorSlice.actions;

export default salaryCalculatorSlice.reducer;
